import Rails from '@rails/ujs';
import debounce from 'lodash.debounce';
import { Controller } from '@hotwired/stimulus';
import { runWhenDomLoaded } from '@frontend/utils/dom';

export default class extends Controller {
  static targets = [
    'form',
    'input',
    'results',
    'hideWhileSearching',
    'algoliaSearchLink',
  ];
  static values = { isTestEnv: Boolean };

  connect() {
    const debounceTimeoutInMs = this.isTestEnvValue ? 0 : 1000;
    this.debouncedSubmit = debounce(
      this.submitOrHide.bind(this),
      debounceTimeoutInMs
    );

    if (this.inputTarget.value !== '') {
      runWhenDomLoaded(() => {
        this.submitForm();
        this.formTarget.addEventListener(
          'ajax:complete',
          () => {
            this.inputTarget.scrollIntoView({
              behavior: 'instant',
              block: 'start',
            });
            this.inputTarget.focus({
              preventScroll: false,
              focusVisible: true,
            });
            const pos = this.inputTarget.value.length;
            this.inputTarget.setSelectionRange(pos, pos);
          },
          { once: true }
        );
      });
    }

    if (this.hasAlgoliaSearchLinkTarget) {
      this.algoliaSearchUrl = this.algoliaSearchLinkTarget.href;
    }
  }

  submitOrHide() {
    if (this.inputTarget.value.length > 0) {
      this.submitForm();
    } else {
      this.clearResults();
    }
  }

  submitFormDebounced() {
    this.debouncedSubmit.call();
  }

  submitForm() {
    Rails.fire(this.formTarget, 'submit');
  }

  applyResults(event) {
    if (event.target !== this.formTarget) {
      return false;
    }

    this.updateUrls();
    this.clearResults();

    const [, , xhr] = event.detail;
    this.hideWhileSearchingTarget.insertAdjacentHTML(
      'beforebegin',
      xhr.responseText
    );

    this.hideWhileSearchingTarget.classList.add('hidden');
  }

  updateUrls() {
    const query = encodeURIComponent(this.inputTarget.value);
    let querySuffix = '';
    if (query.length > 0) {
      querySuffix = `?search_query=${query}`;
    }

    if (history) {
      history.replaceState({ query }, '', `${location.pathname}${querySuffix}`);
    }

    if (this.algoliaSearchUrl) {
      this.algoliaSearchLinkTarget.href = `${this.algoliaSearchUrl}${querySuffix}`;
    }
  }

  clearResults() {
    this.updateUrls();
    if (this.hasResultsTarget) this.resultsTarget.remove();
    this.hideWhileSearchingTarget.classList.remove('hidden');
  }
}
